import 'core-js/proposals/reflect-metadata';
import { jsonProperty, Serializable } from 'ts-serializable';

class EstadoDTO extends Serializable {
    @jsonProperty(String)
    id: string = '';

    @jsonProperty(String)
    nome: string = '';

    constructor() {
        super();
    }
}

export default EstadoDTO;
